import gsap from 'gsap'
import { shuffle } from './utils/array'
import { SplitText } from 'gsap/SplitText.js';

gsap.registerPlugin(SplitText);

export function animatePreloader() {
    const preloader = document.getElementById('preloader')
    const head = document.getElementById('preloaderHead')
    const content = document.getElementById('preloaderContent')
    const logo = document.getElementById('preloaderLogo')

    const CHARACTER_CHANGES = 5;
    const CHARACTER_CHANGE_DELAY = 16;
    const STAGGER = .01
    const VISIBLE_DURATION = .5
    const CHARACTERS = '!@#$%&+=qertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM\\/{}][-_()<>?'.split('')

    const tl = gsap.timeline({
        onComplete: () => {
            setTimeout(() => {
                preloader.remove()
            }, 1000);

            setTimeout(() => {
                window.preloaderPromiseResolve()
            }, CHARACTER_CHANGES*CHARACTER_CHANGE_DELAY);
        }
    })

    if(sessionStorage.getItem('locomotive.quickpreload') == 'true') {
        let logoChildren = shuffle(Array.from(logo.children));
        tl.set(logoChildren, { opacity: 0, stagger: .025 }, 0)
        tl.add(window.preloaderPromiseResolve, .1)
    } else {
        sessionStorage.setItem('locomotive.quickpreload', 'true')

        gsap.set([content], { clearProps: 'display' })

        const contentBlocksSplits = []
        for(let el of content.children) {
            contentBlocksSplits.push(new SplitText(el, { type: 'chars, lines' }));
        }

        let logoChildren = shuffle(Array.from(logo.children));
        tl.set(logoChildren, { opacity: 0, stagger: .05 }, 0.25)

        for(let block = 0; block < contentBlocksSplits.length; block++) {
            const split = contentBlocksSplits[block];

            for(let i = 0; i < split.chars.length; i++) {
                const char = split.chars[i]

                tl.set(char, {
                    opacity: 0
                }, 0)

                tl.set(char, {
                    opacity: 1
                }, block*0.25 + i*STAGGER)

                tl.add(() => {
                    const original = char.innerText;
                    for(let j=0;j<CHARACTER_CHANGES;j++) {
                        setTimeout(() => {
                            char.innerText = CHARACTERS[Math.floor(Math.random()*CHARACTERS.length)]
                        }, j*CHARACTER_CHANGE_DELAY);
                    }
                    setTimeout(() => {
                        char.innerText = original
                    }, CHARACTER_CHANGES*CHARACTER_CHANGE_DELAY);
                }, block*0.25 + i*STAGGER)

                let disappearDelay = block*0.25 + i*STAGGER+VISIBLE_DURATION;
                if(char.parentNode == split.lines[split.lines.length-1]) {
                    disappearDelay = block*0.25 + i*STAGGER+VISIBLE_DURATION+1
                }

                tl.add(() => {
                    for(let j=0;j<CHARACTER_CHANGES;j++) {
                        setTimeout(() => {
                            char.innerText = CHARACTERS[Math.floor(Math.random()*CHARACTERS.length)]
                        }, j*CHARACTER_CHANGE_DELAY);
                    }
                    setTimeout(() => {
                        gsap.set(char, { opacity: 0 });
                    }, CHARACTER_CHANGES*CHARACTER_CHANGE_DELAY);
                }, disappearDelay)
            }
        }
    }
}
